/* eslint-disable no-unused-vars */
import BasePresenter from './base-presenter';
import { presenterType } from './type';

/**
 * 存储presenter class
 */
class ClassMap<A extends BasePresenter> {
    private classMap: Map<any, presenterType<A>> = new Map<any, presenterType<A>>();

    /**
     * 存储BasePresenter
     * @param key
     * @param value
     */
    public setClass(key: any, value: presenterType<A>) {
        this.classMap.set(key, value);
    }

    /**
     * 获取BasePresenter
     * @param key
     */
    public getClass(key: any): presenterType<A> | undefined {
        return this.classMap.get(key);
    }

    /**
     * 清空map
     */
    public clear() {
        this.classMap.clear();
    }

    public size(): number {
        return this.classMap.size;
    }
}

const classMap = new ClassMap<BasePresenter>();

export default classMap;

